import { FC, ReactNode, memo } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { GradientTypography } from '../../gradients/GradientTypography';
import { LoadingButton } from '../../buttons/LoadingButton';
import { useWizard } from '../../wizard/Wizard';
import { DialogNavbar } from '../../dialog/DialogNavbar';

export type EventFlowBaseProps = {
  title: string;
  subtitle?: string;
  Content: ReactNode;
  nextPageKey: string;
  continueText?: string;
  ContinueButton?: ReactNode;
  continueDisabled?: boolean;
  disableNav?: boolean;
};

export const EventFlowBase: FC<EventFlowBaseProps> = memo(
  function EventFlowBaseUnmemoized({
    title,
    subtitle,
    Content,
    nextPageKey,
    continueText = 'Next',
    ContinueButton,
    disableNav = false,
    continueDisabled = false,
  }) {
    const { go, prev } = useWizard();

    return (
      <Fade in timeout={{ enter: 250 }}>
        <Box minWidth="100%" maxWidth="100%">
          {!disableNav && (
            <DialogNavbar
              goBack={() => {
                go(prev);
              }}
              onClose={() => {
                go(undefined);
              }}
              prevDialogId={prev}
            />
          )}
          <DialogTitle
            component="span"
            sx={{ padding: '0px !important', marginTop: '-8px' }}
          >
            <GradientTypography
              gradientColor="primary.vertical"
              variant="h4"
              sx={{ textTransform: 'uppercase' }}
            >
              {title}
            </GradientTypography>
            <Typography color="text.secondary">{subtitle}</Typography>
          </DialogTitle>
          <DialogContent sx={{ mt: 4, mb: 7, maxWidth: '100%' }}>
            {Content}
          </DialogContent>
          <DialogActions>
            {ContinueButton || (
              <LoadingButton
                fullWidth
                color="primary"
                disabled={continueDisabled}
                variant="containedHorizontal"
                onClick={async () => {
                  return go(nextPageKey);
                }}
              >
                {continueText}
              </LoadingButton>
            )}
          </DialogActions>
        </Box>
      </Fade>
    );
  },
);
